angular.module('CarsSaraBo').factory('OpaqueRateService', ['$resource', function($resource) {
    return {
        resource: $resource('../rest/company/:companyOid/opaquerate/:oid',
        { companyOid : '@companyOid'},
        {
            post: {method: 'POST'},
            delete: {method: 'DELETE'},
            get: {method: 'GET'},
            getOne: {method: 'GET'},
            moderate: {method: 'PATCH'}
        }),
        fetchAll: function (companyOid) {
            return this.resource.get(companyOid).$promise;
        },
        fetchByFilter: function (filter, page, offset) {
            var params = {pageNumber: page, itemsPerPage: offset};
            angular.extend(params, filter);
            return this.resource.get(params).$promise;
        },
        remove: function (companyOid, oid) {
            return this.resource.delete({companyOid: companyOid, oid: oid}).$promise;
        },
        save: function (companyOid, opaqueRate) {
            var requestBody = angular.copy(opaqueRate);
            return this.resource.post({companyOid: companyOid}, requestBody).$promise;
        }
    }
}]);




//////////////////
// WEBPACK FOOTER
// ./public/app/opaque-rate/opaque-rate.service.js
// module id = 833
// module chunks = 3